// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerDefault_banner__lHQ6v"};